export function MenuBackArrow({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M6.458 11.42.947 5.91 6.458.397l1.17 1.159-3.505 3.506h8.517v1.693H4.123l3.506 3.5-1.17 1.165Z"
      />
    </svg>
  );
}
